import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doDoorKnock, doTransition, doWaitImageByTime, isAnnGF, isJoeEnemy } from "../helpers/helpers";
import { images } from "./images";
import { V7AnnHouseAfter } from "./V7";

export const V7AnnHouse = async (): Promise<any> => {
    doTransition(images.v7.V7AnnHouse_0);
    doDoorKnock();
    vanessa.talk(`HELLO!!! Open up!`);
    if (mc.properties.annStatus === "hate") {
        return jump(V7AnnHouse_Hate, "V7AnnHouse_Hate");

    } else {

    }
    doWaitImageByTime(images.v7.V7AnnHouse_1);
    ann.talk(`Vanessa? ${mc.name}? What happened?`);
    ann.talk(`Why are you knocking like that?`);
    vanessa.talk(`We're in a hurry and I need you to try something on.`);
    ann.talk(`I can't... I need to study. I've actually --`);
    ImageClass.setImage(images.v7.V7AnnHouse_2);
    vanessa.talk(`I said no time.`);
    ann.talk(`But Vanessa! I really need to study. It's important and I don't have much time!`);
    ann.talk(`Oh my God.`);
    ImageClass.setImage(images.v7.V7AnnHouse_3);
    ann.talk(`Come in I guess.`);
    ImageClass.setImage(images.v7.V7AnnHouse_4, { duration: 1 });
    ann.talk(`I hope it's going to be quick.`);
    vanessa.talk(`It will, if you make it quick.`);
    ann.talk(`Ok...`);
    vanessa.talk(`So ${mc.name} got you a present.`);
    ann.talk(`If it's his present why are you giving it to me?`);
    vanessa.talk(`Because we need to return it.`);
    ann.talk(`That makes... No sense...`);
    ann.talk(`And if you need to return it, it's not really a present...`);
    ImageClass.setImage(images.v7.V7AnnHouse_5);
    vanessa.talk(`Just look.`);
    ann.talk(`Ok...`);
    ImageClass.setImage(images.v7.V7AnnHouse_6);
    vanessa.talk(`Here!`);

    ann.talk(`And what is that?`);
    ImageClass.setImage(images.v7.V7AnnHouse_7);
    vanessa.talk(`Something that will make you feel hot!`);
    ann.talk(`I don't know about that...`);
    ImageClass.setImage(images.v7.V7AnnHouse_6);
    vanessa.talk(`Just try it.`);
    ann.talk(`Right now? No way!`);
    ImageClass.setImage(images.v7.V7AnnHouse_8);
    vanessa.talk(`Come on, put it on.`);
    ann.talk(`Hey!`);
    vanessa.talk(`I said no time!`);
    await empty.set((properties) => {
        properties.tempBool = false;
    });
    ImageClass.setImage(images.v7.V7AnnHouse_9);
    ann.talk(`Why are you in such a hurry in the first place?`);
    vanessa.talk(`We borrowed it, and we need to return it in less than two hours.`);
    ImageClass.setImage(images.v7.V7AnnHouse_11);
    await vanessa.setQuestion(new Question({ text: `Come on ${mc.name}, tell her!`, options: { think: false }, key: `v7AnnHouseEncouragedToWearOutfit` })
        .option({ title: `Encourage her to wear it`, key: true })
        .option({ title: `Don't encourage`, key: false }));


    if (Question.globalAnswers.v7AnnHouseEncouragedToWearOutfit) {
        await ann.set((properties) => {
            properties.corruption++;
        });
        mc.talk(`I agree with Vanessa, you should wear it.`);
        ImageClass.setImage(images.v7.V7AnnHouse_9);
        vanessa.talk(`You see.`);
        mc.talk(`It is a present I got especially for you.`);
        ImageClass.setImage(images.v7.V7AnnHouse_10);
        ann.talk(`Thanks! Hehe.`);
        ann.talk(`But what is it anyway?`);
        ImageClass.setImage(images.v7.V7AnnHouse_9);
        vanessa.talk(`I've already told you! It's a sexy outfit.`);
        vanessa.talk(`I'm serious, try it. It will make you feel sexy.`);
        vanessa.talk(`Not long ago you asked for my help didn't you?`);
        if (Question.globalAnswers.v5admittedItWasAnnsIdea) {
            ann.talk(`I asked ${mc.name} not to say it was my idea...`);
            vanessa.talk(`That's not the point!`);
        } else {

        }
        vanessa.talk(`I'm trying to help you. Just try it!`);
        vanessa.talk(`Put it on and off...real quick...no biggie.`);
        if (ann.properties.corruption > 7) {
            await empty.set((properties) => {
                properties.tempBool = true;
            });
            ImageClass.setImage(images.v7.V7AnnHouse_10);
            ann.talk(`You know what?! I'll do it!`);
            vanessa.talk(`...`);
            ImageClass.setImage(images.v7.V7AnnHouse_9);
            vanessa.talk(`Aren't you going to drop your clothes?`);
            ann.talk(`Not here... I'll do it in the bathroom, give me two minutes.`);
            ImageClass.setImage(images.v7.V7AnnHouse_12);
            vanessa.talk(`Oh my Goooood.`);
            vanessa.talk(`Just do it quick.`);

            ImageClass.setImage(images.v7.V7AnnHouse_24, { duration: 1 });
            vanessa.talk(`I can't believe that it worked!`);
            mc.talk(`What can I say... You have ways of convincing people.`);
            vanessa.talk(`I know! It is one of my many superpowers!`);
            ImageClass.setImage(images.v7.V7AnnHouse_25);
            vanessa.talk(`What the fuck is she studying?`);
            vanessa.talk(`A pandemic is an epidemic of an infectious disease that has spread across a large region, for instance multiple continents or worldwide...`);
            vanessa.talk(`...Bla bla bla global outbreak... Bla bla... A pandemic can happen at any time...`);
            vanessa.talk(`Yeah right. Like this can happen nowadays... Humanity is so advanced no way it can happen in this modern age.`);
            ImageClass.setImage(images.v7.V7AnnHouse_26, { duration: 1 });
            ann.talk(`I'm back...`);
            await vanessa.setQuestion(new Question({ text: `WOW!`, options: { think: false }, key: `v7AnnHouseComplimentedOnTheOutfit` })
                .option({ title: `Compliment her`, key: true })
                .option({ title: `Don't compliment`, key: false }));


            if (Question.globalAnswers.v7AnnHouseComplimentedOnTheOutfit) {
                await mc.set((properties) => {
                    properties.annRelationship++;
                });
                mc.talk(`I agree! You look amazing.`);
                ann.talk(`I don't know. I don't feel amazing.`);
            } else {

            }
            ImageClass.setImage(images.v7.V7AnnHouse_27);
            vanessa.talk(`You should feel SEXY!`);
            ann.talk(`Maybe you are used to wearing this kind of stuff...`);
            ann.talk(`I don't feel comfortable with it.`);
            vanessa.talk(`How can you when you are standing like that?`);
            vanessa.talk(`Come on, make a pose for your boyfriend! Show him what you got!`);
            ann.talk(`Hehe.`);
            vanessa.talk(`Come on! Don't be shy.`);
            ann.talk(`Ok!`);
            vanessa.talk(`Wait.`);
            ImageClass.setImage(images.v7.V7AnnHouse_28);
            vanessa.talk(`Take these off first.`);
            ImageClass.setImage(images.v7.V7AnnHouse_29);
            vanessa.talk(`Now you are ready!`);

            ImageClass.setImage(images.v7.V7AnnHouse_30, { duration: 1 });
            vanessa.talk(`DAMN GIRL!`);
            vanessa.talk(`Looking good!`);
            vanessa.talk(`${mc.name} can't take his eyes off you!`);
            mc.talk(`You look hot.`);
            ann.talk(`Hehe.`);
            ImageClass.setImage(images.v7.V7AnnHouse_31);
            vanessa.talk(`Ok, take your glasses back, we got to go.`);
            ann.talk(`Really? You've went out of your way just for this?`);
            vanessa.talk(`Yes.`);
            vanessa.talk(`Come on, take it. We will be late and ${mc.name} will get his ass kicked.`);
            ann.talk(`Huh? Why?`);
            vanessa.talk(`We'll tell you later.`);
            ann.talk(`Wait.`);


        } else {
            ann.talk(`I don't know about that...`);
            vanessa.talk(`Ann!`);
            ann.talk(`I'm sorry, It's just not like me.`);
            ImageClass.setImage(images.v7.V7AnnHouse_12);
            vanessa.talk(`Oh my God.`);
            vanessa.talk(`Never mind, I'm over it already.`);
            ImageClass.setImage(images.v7.V7AnnHouse_11);
            vanessa.talk(`Come on ${mc.name}, let's go.`);
            ImageClass.setImage(images.v7.V7AnnHouse_9);
        }

    } else {
        ImageClass.setImage(images.v7.V7AnnHouse_11);
        mc.talk(`Now that I think about it... I don't know if that's the best idea.`);

        vanessa.talk(`Are you serious with me right now?`);
        ImageClass.setImage(images.v7.V7AnnHouse_12);
        vanessa.talk(`Why did you let me come over here if you didn't want her to wear it?!`);
        mc.talk(`It's easier just to follow your lead than to argue.`);
        ImageClass.setImage(images.v7.V7AnnHouse_11);
        vanessa.talk(`That's true, but what the fuck ${mc.name}?!`);
        if (ann.properties.corruption > 7) {
            ImageClass.setImage(images.v7.V7AnnHouse_10);
            ann.talk(`To be honest, I would've tried it on if ${mc.name} wanted.`);
            ImageClass.setImage(images.v7.V7AnnHouse_12);
            vanessa.talk(`See what you did?!`);
            ann.talk(`I respect his choice!`);

        } else {
            ImageClass.setImage(images.v7.V7AnnHouse_10);
            ann.talk(`You saved me from embarrassing myself!`);
            mc.talk(`Of course!`);

        }
        ImageClass.setImage(images.v7.V7AnnHouse_11);
        vanessa.talk(`Ugh. There is nothing to do here now.`);
        vanessa.talk(`${mc.name}, let's go.`);
        ImageClass.setImage(images.v7.V7AnnHouse_9);
    }


    ann.talk(`Wait...`);
    ann.talk(`I need a moment alone with ${mc.name}.`);
    vanessa.talk(`NOW?!`);
    ann.talk(`Yes, it's important.`);
    vanessa.talk(`Oh my God... I'll be outside, do it quick.`);

    return jump(V7AnnHouse_Conversation, "V7AnnHouse_Conversation");
};
export const V7AnnHouse_Conversation = async (): Promise<any> => {
    doWaitImageByTime(images.v7.V7AnnHouse_15);
    ann.talk(`Sorry for not giving you any attention... You know what it's like when Vanessa is around... Things can go crazy.`);
    ImageClass.setImage(images.v7.V7AnnHouse_14);
    mc.talk(`Yeah...`);
    if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor) {
        // TODO: first time talking after Joe rival blowjob [if happened]

    } else {

    }
    if (Game.seenScenarios.includes(`V7AnnPure`)) {
        mc.talk(`So what's on your mind?\nYou said you wanted to talk in person.`);
        mc.talk(`Right now is a perfect opportunity.`);
    } else {
        mc.talk(`So what's on your mind?\nIt looks like something is bothering you.`);
        ImageClass.setImage(images.v7.V7AnnHouse_15);
        ann.talk(`Is it that obvious?`);

    }
    ImageClass.setImage(images.v7.V7AnnHouse_15);
    ann.talk(`Well I wanted to talk to you all day but I kept postponing it.`);
    ImageClass.setImage(images.v7.V7AnnHouse_14);
    mc.talk(`I'm here now.`);
    ImageClass.setImage(images.v7.V7AnnHouse_16);
    ann.talk(`Yes.`);
    ann.talk(`Ok... So... You know why I'm studying so hard, right?`);
    ImageClass.setImage(images.v7.V7AnnHouse_17);
    mc.talk(`Yes, to get into a great college.`);
    ImageClass.setImage(images.v7.V7AnnHouse_16);
    ann.talk(`Yes...`);
    // TODO: make up a name
    ann.talk(`So I applied to my dream college, and after they saw my grades they wanted to offer me a scholarship.`);
    ImageClass.setImage(images.v7.V7AnnHouse_17);
    mc.talk(`That's great news! You should be thrilled... Right?`);
    ImageClass.setImage(images.v7.V7AnnHouse_15);
    mc.talk(`I should....`);
    ann.talk(`I'll just say it...`);
    ann.talk(`The scholarship is not certain. I still need to do the college entrance exams, and they want me to do that at their campus.`);
    ann.talk(`They also said they are going to have me stay at the dorms while taking them.`);
    ImageClass.setImage(images.v7.V7AnnHouse_16);
    ann.talk(`I don't know how long it's going to take... It might be a day or even longer.`);
    ImageClass.setImage(images.v7.V7AnnHouse_17);
    mc.talk(`Why the hell does it need to take more than a day to do some exams?`);
    ImageClass.setImage(images.v7.V7AnnHouse_16);
    ann.talk(`I don't know. They have strict rules.`);
    ann.talk(`And that brings me to my point...`);
    ann.talk(`...`);
    ann.talk(`Can you sit down for a second?`);
    ImageClass.setImage(images.v7.V7AnnHouse_20, { duration: 1 });
    ann.talk(`If I get accepted, the semester starts in a few months... And I might need to move there until I'm done.`);
    ann.talk(`It could take a few years...`);
    ann.talk(`It would be selfish of me to ask you to wait for me...`);
    ImageClass.setImage(images.v7.V7AnnHouse_19);
    ann.talk(`I know there is still time. But I think it's only fair to give you the choice.`);
    ann.talk(`But please, don't answer right now... Sleep on it.`);
    ImageClass.setImage(images.v7.V7AnnHouse_20);
    ann.talk(`I care for you and I want to stay together, but I will respect any decision you make.`);
    ImageClass.setImage(images.v7.V7AnnHouse_19);
    ann.talk(`We can make it work, we can talk on webcam every day. And you can come visit anytime you'd like!`);
    ImageClass.setImage(images.v7.V7AnnHouse_21);
    ann.talk(`I'll also come back here on summer breaks!`);
    ImageClass.setImage(images.v7.V7AnnHouse_19);
    mc.talk(`Oh wow, that's a.... That's a lot to take in Ann.`);
    ImageClass.setImage(images.v7.V7AnnHouse_22);
    ann.talk(`I know. I'm sorry, I didn't want to do it here. Like this.`);
    ann.talk(`But I also couldn't let you leave without coming clean.`);
    mc.talk(`So wait, when do you leave?`);
    ImageClass.setImage(images.v7.V7AnnHouse_20);
    ann.talk(`I don't know, I'm waiting for a call from them.`);
    ann.talk(`Just think about what I said... And you know where I stand.`);
    mc.talk(`I will definitely think about it.`);

    ImageClass.setImage(images.v7.V7AnnHouse_19);
    await ann.setQuestion(new Question({ text: `Thank you.`, options: { think: false }, key: `v7AnnHomeKissHerAfterConversation` })
        .option({ title: `Kiss her`, key: true })
        .option({ title: `Don't kiss her`, key: false }));

    if (Question.globalAnswers.v7AnnHomeKissHerAfterConversation) {
        await mc.set((properties) => {
            properties.annRelationship += 2;
        });
        ImageClass.setImage(images.v7.V7AnnHouse_23, { duration: 1 });
        mc.talk(`Muah!`);
        ImageClass.setImage(images.v7.V7AnnHouse_21);
        ann.talk(`Hehe!`);
        ann.talk(`You made me feel a lot better.`);
        ann.talk(`I was scared you would just walk out the door and never speak to me again.`);
        mc.talk(`Don't be silly. Even though we really just met, I also care for you a lot and would never do that.`);
        mc.talk(`I'll talk to you later, I just need to finish this thing with Vanessa.`);
        ann.talk(`Ok!`);
    } else {
        ImageClass.setImage(images.v7.V7AnnHouse_22);
        mc.talk(`Bye Ann.`);
    }


    return jump(V7AnnHouse_VanessaOutside, "V7AnnHouse_VanessaOutside");
};
export const V7AnnHouse_Hate = async (): Promise<any> => {
    doWaitImageByTime(images.v7.V7AnnHouseHate_1);
    ann.talk(`*Yawn*`);
    ann.talk(`Vanessa? ${mc.name}?`);
    ann.talk(`*Yawn* What happened?`);
    vanessa.talk(`Why are you still sleeping at this hour?`);
    ImageClass.setImage(images.v7.V7AnnHouseHate_1.partials.V7AnnHouseHate_1_p);
    ann.talk(`I'm not sleeping anymore.`);
    vanessa.talk(`...`);
    vanessa.talk(`I need you to try something on real quick.`);
    ImageClass.setImage(images.v7.V7AnnHouseHate_1.partials.V7AnnHouseHate_1_p_2);
    ann.talk(`Now? I just woke up.`);
    vanessa.talk(`You are almost naked so it will be quick.`);
    ImageClass.setImage(images.v7.V7AnnHouseHate_1.partials.V7AnnHouseHate_1_p);
    ann.talk(`Ok get in but be quiet. Chris is sleeping.`);
    ImageClass.setImage(images.v7.V7AnnHouseHate_2, { duration: 1 });
    ann.talk(`Hey ${mc.name}.`);
    mc.talk(`Hey Ann.`);
    ImageClass.setImage(images.v7.V7AnnHouseHate_3);
    if (Question.globalAnswers.v1EnableNTR) {
        await ann.setQuestion(new Question({ text: `Are you coming in as well?`, options: { think: false }, key: `v7AnnHouseHateWentInside` })
            .option({ title: `Go inside`, key: true })
            .option({ title: `Stay outside`, key: false }));
    } else {

    }


    if (Question.globalAnswers.v7AnnHouseHateWentInside) {
        doTransition(images.v7.V7AnnHouseHate_4);
        ann.talk(`Be quiet! I don't want to wake him up.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_4.partials.V7AnnHouseHate_4_p);
        ann.talk(`We went to sleep late after a long night hehe.`);
        vanessa.talk(`Don't worry I'll be as quiet as I can.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_5);
        vanessa.talk(`So look here.`);
        ann.talk(`Huh? What's that?`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_6);
        vanessa.talk(`What do you think?`);
        ann.talk(`I don't know, I need to check if Chris likes it.`);
        vanessa.talk(`You are right.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_7);
        ann.talk(`Vanessa!`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_8, { wait: true });
        ImageClass.setImage(images.v7.V7AnnHouseHate_9);
        chris.talk(`What the hell is going on here?`);
        vanessa.talk(`Ann wants your opinion on this.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_10);
        ann.talk(`I'm sorry. I didn't know she'd do that.`);
        chris.talk(`Mmm...`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_11);
        chris.talk(`It looks sexy.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_11.partials.V7AnnHouseHate_11_p);
        chris.talk(`Leave it here so we could "test" it out. Haha.`);
        vanessa.talk(`We can't.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_11);
        vanessa.talk(`We need to return it. Like now.`);
        ann.talk(`Do you want me to put it on?`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_11.partials.V7AnnHouseHate_11_p);
        chris.talk(`I won't say no to that.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_13, { duration: 1 });
        ann.talk(`I hope you like it.`);
        vanessa.talk(`Damn girl, look at you.`);
        doWaitImageByTime(images.v7.V7AnnHouseHate_14);
        ann.talk(`Don't peep.`);
        doTransition(images.v7.V7AnnHouseHate_15);
        ann.talk(`Do you like it?`);
        chris.talk(`Come here.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_16);
        ann.talk(`Hehe.`);
        ImageClass.setImage(images.v7.V7AnnHouseHate_17);
        chris.talk(`Can you feel how much I like it?`);
        ann.talk(`I do!`);
        doWaitImageByTime(images.v7.V7AnnHouseHate_18);
        ann.talk(`Leave us alone for a few minutes.`);
        vanessa.talk(`You better do it quick!`);


    } else {
        mc.talk(`I'll wait here, tell Vanessa to do it quick.`);
        ann.talk(`Too bad hehe.`);
        return jump(V7AnnHouse_VanessaOutside, "V7AnnHouse_VanessaOutside");

    }


    return jump(V7AnnHouse_VanessaOutside, "V7AnnHouse_VanessaOutside");
};

export const V7AnnHouse_VanessaOutside = async (): Promise<any> => {
    if (mc.properties.annStatus === "hate") {
        if (Question.globalAnswers.v7AnnHouseHateWentInside) {
            doTransition(images.v7.V7AnnHouseHate_19);
            mc.talk(`Do you think I should've waited outside?`);
            ImageClass.setImage(images.v7.V7AnnHouseHate_21);
            vanessa.talk(`Are you fucking kidding me?`);
            vanessa.talk(`She is going out of her ways to tease you, can't you see it?`);
            ImageClass.setImage(images.v7.V7AnnHouseHate_19);
            vanessa.talk(`I can't believe I'm saying this, but she is totally playing with Chris to get to you.`);
            if (Game.seenScenarios.includes(`V7JennyDate8SuggestExchange`)) {
                mc.talk(`What if Chris is doing the same?`);
                ImageClass.setImage(images.v7.V7AnnHouseHate_19.partials.V7AnnHouseHate_19_p);
                vanessa.talk(`So they have nothing to get angry about.`);
                mc.talk(`True...`);

            } else {
                mc.talk(`I don't know... It looks like they are having fun together.`);

            }
            ImageClass.setImage(images.v7.V7AnnHouseHate_19.partials.V7AnnHouseHate_19_p);
            vanessa.talk(`Are you sure? Like really sure?`);
            vanessa.talk(`I bet they are dying from boredom when you are not around.`);
            ImageClass.setImage(images.v7.V7AnnHouseHate_19);
            mc.talk(`Did you see the vodka and glasses on her counter?`);
            mc.talk(`They clearly were partying last night.`);
            vanessa.talk(`I told you what I think. Your choice to believe it or not.`);
            // TODO: door open sound
            doWaitImageByTime(images.v7.V7AnnHouseHate_23);
            ann.talk(`There you go.`);
            vanessa.talk(`So soon? Poor you.`);
            doWaitImageByTime(images.v7.V7AnnHouseHate_23.partials.V7AnnHouseHate_23_p);
            ann.talk(`...`);
            ann.talk(`I...`);
            vanessa.talk(`No time! Need to go! Bye!`);

        } else {
            ImageClass.setImage(images.v7.V7AnnHouseHate_22);
            mc.think(`I don't have anything to do inside.`);
            mc.think(`She is with Chris now after I turned her down. I better give them the space they need.`);
            doTransition(images.v7.V7AnnHouseHate_20);
            vanessa.talk(`Why didn't you go in?`);
            mc.talk(`I like the fresh air.`);
            ImageClass.setImage(images.v7.V7AnnHouseHate_21);
            vanessa.talk(`Don't you want to see Ann wearing that thing?`);
            ImageClass.setImage(images.v7.V7AnnHouseHate_19);
            mc.talk(`No.`);
            vanessa.talk(`...`);
            mc.talk(`Can we go now?`);
            vanessa.talk(`Sure.`);
        }


    } else {
        doTransition(images.v7.V7AnnHouse_32);
        vanessa.talk(`What took you so long, did you break up?`);
        mc.talk(`Sort of.`);
        ImageClass.setImage(images.v7.V7AnnHouse_33);
        vanessa.talk(`WHAT?`);
        mc.talk(`She might be leaving soon for some college entrance exams.`);
        vanessa.talk(`WHAAAAAT?!`);
        mc.talk(`I think you should try to talk to her once in while.`);
        ImageClass.setImage(images.v7.V7AnnHouse_34);
        vanessa.talk(`I am!!! I can't believe she hadn't told me any of this.`);
        vanessa.talk(`I'll kick her ass once we are back!`);

    }
    return jump(V7AnnHouseAfter, "V7AnnHouseAfter");
};